import gql from "graphql-tag";

// Resolver signature confirmed against mediajel-gql-service
// src/webapp/schema.graphql:
//   getHashedEmailPartitionDownloadUrl(hashedEmailListId: ID!, orgID: ID!, fileName: String!): JSON
// orgID is required — the resolver enforces tenant scoping — and fileName
// must be one of the audience's own published partitions (its csvFileName),
// otherwise the resolver returns { success: false, error }. On success it
// returns { success: true, downloadUrl, expiresInSeconds } — a pre-signed S3
// GET valid for 300s.
const GET_HASHED_EMAIL_PARTITION_DOWNLOAD_URL = gql`
  query getHashedEmailPartitionDownloadUrl(
    $hashedEmailListId: ID!
    $orgID: ID!
    $fileName: String!
  ) {
    getHashedEmailPartitionDownloadUrl(
      hashedEmailListId: $hashedEmailListId
      orgID: $orgID
      fileName: $fileName
    )
  }
`;

export default GET_HASHED_EMAIL_PARTITION_DOWNLOAD_URL;
